export default __webpack_public_path__ + "static/media/icLocation.605120c4.svg";